import React from "react";
import CustomButton from "../ui/Button";
import { useTranslation } from "react-i18next";


const SafetySection = () => {
  const { t } = useTranslation("home"); // Hook to use translations

  return (
    <div className="relative mx-auto px-[30px] max-w-[1220px] flex flex-col md:flex-row items-center">
      <div className="flex flex-col md:flex-row items-center w-full mt-[53px] mb-[70.45px]">
        <div
          style={{
            position: "absolute",
            left: "-13rem",
            top: "-8rem",
          }}
        >
          <img src="/assets/ellipse.svg" alt="Ellipse" className="w-21 h-33" />
        </div>

        {/* Left Section with Card */}
        <div className="w-full md:w-1/2 mb-8 md:mb-0 h-[581px] md:pl-2 relative">
          <div className="rounded-xl overflow-hidden shadow-lg h-full lg:mr-12">
            <img
              src="/assets/supporting.png"
              alt="Safety Work Environment"
              className="w-[514px] h-[581px] object-cover transition-transform duration-[1500ms] ease-in-out transform hover:scale-125"

            />
          </div>
        </div>

        {/* Right Section with Text */}
        <div className="w-full md:w-1/2 text-white flex flex-col justify-center md:pl-10">
          <div className="title-small gradient-text font-semibold py-2 px-4 rounded-full mb-6 border border-color w-fit ">

            {t("safety_first")}

          </div>
          <h2 className="web-heading-card-4 text-color-2 tracking-[-1.2px] mb-4">

            {t("supporting_safer_workforce")}

          </h2>
          <p className="body-large text-color mb-4">

            {t("tauken_safety_tools")}

          </p>
          <div className="flex flex-col md:flex-row gap-8">
            <div className="flex-1">
              <h3 className="title-medium-2 text-color-2 mb-2">

                {t("optimize_operations_safely")}

              </h3>
              <p className="body-medium-2 text-color mb-4">
                {t("enhance_efficiency_safety")}

              </p>
            </div>
            <div className="flex-1">
              <h3 className="title-medium-2 text-color-2 mb-2">

                {t("prioritize_workforce_safety")}


              </h3>
              <p className="body-medium-2 text-color mb-4">
                {t("employee_wellbeing_first")}

              </p>
            </div>
          </div>
          <a href="/safety_management" className="relative z-10">
            <CustomButton className="w-fit mt-8">
              {t("explore_safety_solutions")}

            </CustomButton>
          </a>




        </div>
      </div>
    </div>
  );
};

export default SafetySection;
